import { Button } from 'antd';
import { FullUserBoundary } from '@ui/general';
import React from 'react';
import { useCurrentOrganizationSubdomain } from '@hooks';

import { COPY_SPECIFIC, LINKS } from '@sonar-software/sonar-ts-constants';

export const BlockInSalesforceButton: React.FC = () => {
	const subdomain = useCurrentOrganizationSubdomain();

	return (
		<FullUserBoundary>
			<Button
				className='block-in-salesforce-button'
				danger
				onClick={ () => window.open(LINKS.SALESFORCE_MANAGE_APPS(subdomain), '_blank', 'noopener,noreferrer') }
				size='small'>
				{ COPY_SPECIFIC.BLOCK_IN_SALESFORCE }
			</Button>
		</FullUserBoundary>
	);
};
